import Prismic from 'prismic-javascript';

const apiEndpoint = 'https://daye.cdn.prismic.io/api/v2';
export const prismicVitals = Prismic.client(apiEndpoint);

export function getArticleInfo(setArticleInfo, limit = 100, hideInUS = false) {
  prismicVitals
    .query([Prismic.Predicates.at('document.type', 'articles')], {
      orderings: '[document.first_publication_date desc]',
      pageSize: limit,
      fetch: [
        'articles.title',
        'articles.article_subheadline',
        'articles.featured_image',
        'articles.article_read_time',
        'articles.category',
        'articles.hide_in_us',
        'articles.hide_in_index'
      ]
    })
    .then((response) => {
      let articles = response.results;

      if (hideInUS) {
        articles = articles.filter((a) => !a.data.hide_in_us);
      }
      articles = articles.filter((a) => !a.data.hide_in_index);
      setArticleInfo(articles);
    })
    .catch((err) => console.error('No articles found', err));
}

export function getArticleInfoSearch(setArticleInfo, limit = 100, country = 'US') {
  prismicVitals
    .query([Prismic.Predicates.at('document.type', 'articles')], {
      orderings: '[document.first_publication_date desc]',
      pageSize: limit,
      fetch: [
        'articles.title',
        'articles.article_subheadline',
        'articles.featured_image',
        'articles.article_read_time',
        'articles.category',
        'articles.hide_in_us',
        'articles.hide_in_index',
        'articles.body'
      ]
    })
    .then((response) => {
      let articles = response.results;
      if (country === 'US') {
        articles = articles.filter((a) => !a.data.hide_in_us);
      }
      articles = articles.filter((a) => !a.data.hide_in_index);
      setArticleInfo(articles);
    })
    .catch((err) => console.error('No articles found', err));
}

export function getCategories(setCategories) {
  prismicVitals
    .query(Prismic.Predicates.at('document.type', 'categories'), {
      fetch: [
        'categories.title',
        'categories.category_color',
        'categories.category_nav_order',
        'categories.category_description',
        'categories.category_image'
      ]
    })
    .then((response) => {
      const sortedResults = response.results.sort((a, b) => (a.data.category_nav_order > b.data.category_nav_order ? 1 : -1));
      setCategories(sortedResults);
    })
    .catch((err) => console.debug('No categories found', err));
}

export function getGlossary(setGlossary) {
  prismicVitals.query(Prismic.Predicates.at('document.type', 'tags'), { pageSize: 100 }).then((response) => {
    setGlossary(response.results);
  });
}

export function getPoll(setPolls) {
  prismicVitals
    .query(Prismic.Predicates.at('document.type', 'poll'), {
      fetch: ['categories.title', 'categories.category_color', 'categories.category_nav_order']
    })
    .then((response) => {
      setPolls(response.results);
    });
}

export function getPollAnswers(setAnswer) {
  prismicVitals
    .query(Prismic.Predicates.at('document.type', 'poll'), {
      fetch: ['categories.title', 'categories.category_color', 'categories.category_nav_order']
    })
    .then((response) => {
      setAnswer(response.results);
    });
}

export function getCategoryTitle(setCategoryTitle, categoryId) {
  prismicVitals
    .query(Prismic.Predicates.at('document.type', 'categories'), {
      fetch: ['categories.title']
    })
    .then((response) => {
      const category = response.results;
      const filteredCategory = category.filter((cat) => {
        if (!cat || !categoryId) return false;
        return cat.id === categoryId;
      });
      if (filteredCategory[0]) {
        const filteredCategoryColor = category.filter((cat) => cat.id === filteredCategory[0].id);
        filteredCategoryColor.map((col) => {
          setCategoryTitle(col.data.title);
        });
      }
    })
    .catch((err) => console.debug('No categories found', err));
  return true;
}

export function getCategoryColour(setCategoryColour, categoryProps) {
  prismicVitals
    .query(Prismic.Predicates.at('document.type', 'categories'), {
      fetch: ['categories.title', 'categories.category_color', 'categories.category_nav_order']
    })
    .then((response) => {
      const category = response.results;
      const filteredCategory = category.filter((cat) => {
        if (!cat || !categoryProps) return false;
        return cat.id === categoryProps.id;
      });
      if (filteredCategory[0]) {
        const filteredCategoryColor = category.filter((cat) => cat.id === filteredCategory[0].id);
        filteredCategoryColor.map((col) => {
          setCategoryColour(col.data.category_color);
        });
      }
    })
    .catch((err) => console.debug('No categories found', err));
  return true;
}

export function getSetOfArticles(setArticleInfo, limit = 100, articleUids) {
  prismicVitals
    .query([Prismic.Predicates.any('my.articles.uid', articleUids)], {
      orderings: '[document.first_publication_date desc]',
      pageSize: limit,
      fetch: [
        'articles.title',
        'articles.article_subheadline',
        'articles.featured_image',
        'articles.article_read_time',
        'articles.category',
        'articles.hide_in_us',
        'articles.hide_in_index',
        'articles.navigation_image',
        'articles.navigation_text',
        'articles.navigation_badge_color',
        'articles.hide_in_index',
        'articles.tags'
      ]
    })
    .then((response) => {
      const articles = response.results;
      const orderedArticles = articleUids.map((uid) => articles.find((a) => a.uid === uid)).filter(Boolean);
      setArticleInfo(orderedArticles);
    })
    .catch((err) => console.error('No articles found', err));
}

export const getAudio = (audioId, setActiveAudio) => {
  prismicVitals.query(Prismic.Predicates.at('document.type', 'audio'), {}).then((response) => {
    const res = response.results;
    const activeAudio = res.filter((y) => y.id === audioId);
    if (activeAudio[0]) {
      setActiveAudio(activeAudio[0].data.mp3.url);
    }
  });
};
